import { msg } from "@lingui/core/macro";
import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { GroupDetailPage } from "@/features/domain/components/group-detail-page";
import { useI18n } from "@/providers/i18n-provider";

function GroupDetailRoutePage() {
  const { t } = useI18n();
  const params = useParams({ from: "/_app/groups/$groupId" });
  return (
    <AuthPlaceholder title={t(msg`Group`)} description={t(msg`Sign in to see this group.`)}>
      <PageContainer maxWidth="3xl">
        <GroupDetailPage groupId={params().groupId} />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const groupDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/groups/$groupId",
  component: GroupDetailRoutePage,
});
